import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextCollapse',
  props: {
    clamp: null
  },
  setup(__props: any) {

const props = __props as {
	clamp: number;
};



const clamp = ref<HTMLElement | null>(null);

const isClamped = computed(() => (clamp.value?.scrollHeight || 0) > (clamp.value?.clientHeight || 0));
const lines = computed(() => (isClamped.value ? props.clamp - 1 : props.clamp));
const readMore = ref(false);

return { __sfc: true,props, clamp, isClamped, lines, readMore }
}

})